module.exports = __webpack_public_path__ + "img/GE.637ca972.jpg";